var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TableOrder"},[_c('div',[_c('RecordStoreTable',{ref:"phonetablechild",attrs:{"id":_vm.iiid,"partition":_vm.partition}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }